import { IoCheckmarkDoneSharp, IoCheckmarkSharp } from "react-icons/io5";
import defaultImg from "../../../assets/images/default_profile_img.png";
import { MessageStatus } from "../../../util/MessageConstants";
import { ChatType } from "../../../util/ChatUtils";
import { PhotoProvider, PhotoView } from "react-photo-view";

const ChatMessageCard = ({ message, userInfo, chat }) => {
    const sentTime = new Date(message?.sentTime).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });

    function ChatImageLayout({ images }) {
        //console.log(images);

        const renderImage = (img) => (
            <PhotoView src={img}>
                <img
                    src={img}
                    className="chat-img"
                    alt=""
                />
            </PhotoView>
        );

        switch (images.length) {

            /// ✅ 1 IMAGE
            case 1:
                return (
                    <div className="single">
                        {renderImage(images[0])}
                    </div>
                );

            /// ✅ 2 IMAGE
            case 2:
                return (
                    <div className="row">
                        <div className="flex">{renderImage(images[0])}</div>
                        <div className="flex">{renderImage(images[1])}</div>
                    </div>
                );

            /// ✅ 3 IMAGE
            case 3:
                return (
                    <div className="row">
                        <div className="flex2">
                            {renderImage(images[0])}
                        </div>

                        <div className="column">
                            <div className="flex">{renderImage(images[1])}</div>
                            <div className="flex">{renderImage(images[2])}</div>
                        </div>
                    </div>
                );

            /// ✅ 4 OR MORE
            default:
                return (
                    <div className="grid">
                        {images.map((img, index) => {

                            if (index === 3 && images.length > 4) {
                                return (
                                    <div className="overlay-wrapper" key={index}>
                                        {renderImage(img)}

                                        <div className="overlay">
                                            +{images.length - 4}
                                        </div>
                                    </div>
                                )
                            }
                            if (index <= 3) {
                                return (
                                    <div key={index}>
                                        {renderImage(img)}
                                    </div>
                                )
                            }

                            if (index >= 4) {
                                return (
                                    <div style={{display:'none'}} key={index}>
                                        {renderImage(img)}
                                    </div>
                                )
                            }
                        })}
                    </div>
                );
        }
    }
    return (
        <PhotoProvider>
            <div className={message?.senderId === userInfo?.userId ?
                'sm_chat_message_card_body sm_my_message' : 'sm_chat_message_card_body'}>
                {chat?.chatType === ChatType.GROUP &&
                    <div className='sm_chat_message_card_img'>
                        {message?.senderId !== userInfo?.userId &&
                            <img src={message?.senderProfileImg ? `${import.meta.env.VITE_APP_BASE_URL}/user/user-profile-img/${message?.senderProfileImg}` : defaultImg} alt="" />
                        }
                    </div>}
                <div className={message?.senderId === userInfo?.userId ?
                    'sm_chat_message_card_text sm_my_message'
                    :
                    'sm_chat_message_card_text'
                }>
                    {(chat?.chatType === ChatType.GROUP && message?.senderId !== userInfo?.userId) &&
                        <p className='sm_chat_message_card_user_name'>{message?.senderFirstName + " " + message?.senderLastName}</p>}

                    {message?.messageType === 'IMAGE' &&
                        <div className={`chat-media-box media-${message.images.length}`}>
                            <ChatImageLayout images={message?.images?.map(img => img.imageUrl)} />
                        </div>
                    }

                    {message?.messageType === 'POLL' && <p>Polls aren't supported on web yet. Head to the mobile app to get started.</p>}
                    {(message?.messageType === 'TEXT' || message?.messageType === 'IMAGE') && <p>{message?.content}</p>}

                    <div className="sm_chat_message_time_and_check">
                        <h5>{sentTime}</h5>
                        {message?.senderId === userInfo?.userId &&
                            <>
                                {message?.messageStatus === MessageStatus.SEEN && <IoCheckmarkDoneSharp className="sm_chat_message_seen_status_icon" />}
                                {message?.messageStatus === MessageStatus.DELIVERED && <IoCheckmarkDoneSharp className="sm_chat_message_deliver_status_icon" />}
                                {message?.messageStatus === MessageStatus.SENT && <IoCheckmarkSharp className="sm_chat_message_sent_status_icon" />}
                            </>
                        }
                    </div>
                </div>
            </div>
        </PhotoProvider>
    )
}

export default ChatMessageCard